module.exports = __webpack_public_path__ + "img/gitlab.563f351b.svg";